import React, { useContext } from "react";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import Multibets from "./Multibets";
import Systembets from "./Systembets";

export default function Coupon(props) {
    const betslipContext = useContext(BetslipContext) ;
    const coupon = betslipContext.getCurrentCoupon();
    return (
        <>
            {(coupon.selectedContainer !== 'systembets') && <Multibets couponKey={props.couponKey} showable="true" />}
            {coupon.selectedContainer === 'systembets' && <Systembets couponKey={props.couponKey} showable="true" />}
        </>
    );
}
